export default {
  root: {
    display: 'flex',
  },
  marginDense: {
    marginTop: 0,
    marginBottom: 3,
  },
};
